import { useState, useEffect } from "react";
import axios from "axios";
import ReactFileUpload from "./ReactFileUpload";
import { Typography } from "@mui/material";
import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DocumentComponent } from "../../../features/document/components/document-component";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import { baseUrl } from "../../../config/config";
import { AutosaveDelay, SectionNames } from "../../../constant";

import { fetchDocumentSections } from "../../../redux/slices/documentSectionsSlice";
import { DocumentServices } from "../../../features/document/services/document-services";
import {
  assetID,
  UploadDocument,
  FileChunk,
} from "../../../redux/slices/documentCommentSlice";
import { postApiCall } from "../../../services/apiHelper";
import { changeStatus } from "../../../redux/slices/onChangeSlice";
import { GenericToast } from "components/util/ToastMessage";
import { LoadingButton } from "@mui/lab";
import { getAbfStatusLogs } from "redux/slices/abfStatusSlice";

const _ = require("lodash");

interface toast {
  message: any;
  severity: string;
}

let promises: Promise<any>[] = [];
let largeFiles: FileChunk[] = [];
let largeFilesArray: any[] = [];
const Input = styled("input")({
  display: "none",
});
const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};
const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

interface DocumentsProps {
  mode: string;
}

function Documents(props: DocumentsProps) {
  const dispatch = useAppDispatch();
  const [submitLoaderButton, setSubmitLoaderButton] = useState(false);
  const [toastMessageOpen, setToastMessageOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<toast>({
    message: "",
    severity: "",
  });

  const dapData = useAppSelector((state) => state.summary.dapData);
  const [isSectionValueEmpty, setIsSectionValueEmpty] =
    useState<boolean>(false);

  const assetPlanId = useAppSelector(
    (state) => state.getAssetPlanId.assetPlanId,
  );
  const [sectionValue, setSectionValue] = React.useState<string | null>();
  const documentSections = useAppSelector(
    (state) => state.documentSections.sections,
  );
  const documentSectionsLoading = useAppSelector(
    (state) => state.documentSections.loading,
  );
  const portfolioInvestments = useAppSelector((state) => state.abfStatus.data);
  const [selectedInvestmentId, setSelectedInvestmentId] = useState<string>("");

  const handleInvestmentIdChange = (event: SelectChangeEvent) => {
    setSelectedInvestmentId(event.target.value);
  };

  const documentServices = new DocumentServices();
  const [newUserInfo, setNewUserInfo] = useState({
    profileImages: [],
  });

  const updateUploadedFiles = (files) =>
    setNewUserInfo({ ...newUserInfo, profileImages: files });

  const [documentData, setDocumentData] = useState([]);
  var chunkSize = 2000000;
  const [counter, setCounter] = useState(1);
  var beginingOfTheChunk = 0;
  var endOfTheChunk: any;
  var arrayOfFileChunks: any = [];

  const largeFileUpload = (file: any) => {
    var arrayFileChunk: any = [];
    endOfTheChunk = chunkSize;
    // filesList.forEach((file) => {
    return new Promise((resolve) => {
      // let promise = getBase64(file).then((base64File:any)=>{
      while (beginingOfTheChunk <= file.fileAsBase64.length) {
        var chunk = file.fileAsBase64.slice(beginingOfTheChunk, endOfTheChunk);
        const chunkFile: FileChunk = {
          fileAsBase64: chunk,
          tmpDirectory:
            formatDate(new Date()) + "_" + file.fileName + "_Chunks",
          fileName: file.fileName,
          sectionName: file.sectionName,
          budgetYear: file.budgetYear,
          assetPlanID: file.assetPlanID,
        };
        arrayFileChunk.push(chunkFile);
        setCounter(counter + 1);
        beginingOfTheChunk = endOfTheChunk;
        endOfTheChunk = endOfTheChunk + chunkSize;
      }
      arrayOfFileChunks.push(arrayFileChunk);
      beginingOfTheChunk = 0;
      endOfTheChunk = 0;
      // uploadCompleted(uploadStartResponse,file);
      resolve(arrayOfFileChunks);
      // });
    });

    // });
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {};
    });
  };

  const validateFileType = (
    files: File[],
    selectedSection: string | null | undefined,
  ) => {
    const imageOnlySections = ["Property Images", "Site Plan", "Stacking Plan"];
    const allowedExtensions = [
      ".pdf",
      ".ppt",
      ".pptx",
      ".zip",
      ".jpg",
      ".xlsx",
      ".xlsm",
      ".xlsb",
      ".xls",
      ".doc",
      ".docx",
      ".jpeg",
      ".gif",
      ".png",
      ".bmp",
      ".tiff",
      ".txt",
      ".msg",
      ".csv",
      ".webp",
      ".svg",
    ];

    if (selectedSection && imageOnlySections.includes(selectedSection)) {
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".webp",
        ".svg",
        ".tiff",
      ];
      const invalidFiles = files.filter((file) => {
        const fileExtension = file.name
          .toLowerCase()
          .substring(file.name.lastIndexOf("."));
        return !imageExtensions.includes(fileExtension);
      });

      if (invalidFiles.length > 0) {
        setToastMessageOpen(true);
        setToastMessage({
          message: `Only image files are allowed for ${selectedSection} section`,
          severity: "error",
        });
        setTimeout(() => {
          setToastMessageOpen(false);
        }, 4000);
        return false;
      }
    }

    const invalidExtFiles = files.filter((file) => {
      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));
      return !allowedExtensions.includes(fileExtension);
    });

    if (invalidExtFiles.length > 0) {
      setToastMessageOpen(true);
      setToastMessage({
        message:
          "Only allowed file extensions: .pdf, .ppt, .pptx, .zip, .jpg, .xlsx, .xlsm, .xlsb, .xls, .doc, .docx, .jpeg, .gif, .png, .bmp, .tiff, .txt, .msg, .csv",
        severity: "error",
      });
      setTimeout(() => {
        setToastMessageOpen(false);
      }, 4000);
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    if (!validateFileType(newUserInfo.profileImages, sectionValue)) {
      return;
    }

    setSubmitLoaderButton(true);
    promises = [];
    largeFiles = [];
    let sectionName;
    let fileType;
    if (sectionValue != null) {
      sectionName = sectionValue;
    }
    var asyncDocCreate = new Promise((resolve, reject) => {
      newUserInfo.profileImages.forEach((file: any, index, files: any) => {
        let promise = getBase64(file).then(async (res: any) => {
          res = res.split(",")[1];
          if (file.size > 3000000) {
            const chunkFile: FileChunk = {
              assetPlanID: assetPlanId,
              investmentId: dapData?.investmentId
                ?.toLowerCase()
                .includes("portfolio")
                ? selectedInvestmentId || ""
                : dapData?.investmentId || "",
              sectionName: sectionName,
              budgetYear:
                dapData?.budgetYear != undefined ? dapData?.budgetYear : "",
              fileAsBase64: res,
              tmpDirectory:
                formatDate(new Date()) + "_" + file.name + "_Chunks",
              fileName: file.name,
              fileSize: file.size,
            };
            await largeFileUpload(chunkFile);
            chunkFile.fileAsBase64 = "";
            largeFiles.push(chunkFile);
            promises.push(postApiCall(`${baseUrl}Document/start`, chunkFile));
          } else {
            const doc: UploadDocument = {
              assetPlanID: assetPlanId,
              investmentId: dapData?.investmentId
                ?.toLowerCase()
                .includes("portfolio")
                ? selectedInvestmentId || ""
                : dapData?.investmentId || "",
              sectionName: sectionName,
              budgetYear:
                dapData?.budgetYear != undefined ? dapData?.budgetYear : "",
              comments: "",
              fileName: file.name,
              fileSize: file.size,
              fileType: file.type,
              fileAsBase64: res,
            };
            promises.push(postApiCall(`${baseUrl}Document/AddDocument`, doc));
          }

          if (index === files.length - 1) resolve(promises);
        });
      });
    });

    asyncDocCreate.then((x) => {
      try {
        if (sectionValue != undefined) {
          if (newUserInfo.profileImages.length > 0) {
            setToastMessageOpen(false);
            Promise.all(promises)
              .then((res: any) => {
                setSubmitLoaderButton(false);
                setToastMessageOpen(true);

                const hasFailure = res.some(
                  (r: any) =>
                    r?.result?.succeeded === false ||
                    r?.succeeded === false ||
                    r === false,
                );

                if (hasFailure) {
                  const errorMsg =
                    res.find((r: any) => r?.result?.errorMessage)?.result
                      ?.errorMessage || "Upload failed";
                  setToastMessage({
                    message: errorMsg,
                    severity: "error",
                  });
                } else {
                  setToastMessage({
                    message: "Saved successfully",
                    severity: "success",
                  });
                  uploadChunksFromArray(arrayOfFileChunks);
                }

                loadDocumentData(sectionName);
                dispatch(changeStatus(true));
                setTimeout(() => {
                  setToastMessageOpen(false);
                }, 4000);
              })
              .catch((err: any) => {
                setToastMessageOpen(true);
                setSubmitLoaderButton(false);
                setToastMessage({
                  message: err.message,
                  severity: "error",
                });
                setTimeout(() => {
                  setToastMessageOpen(false);
                }, 4000);
                dispatch(changeStatus(true));
                loadDocumentData(sectionName);
              });
            handleAccordianChange(sectionName);
          } else {
            setSubmitLoaderButton(false);
            setToastMessageOpen(true);
            setTimeout(() => {
              setToastMessageOpen(false);
            }, 4000);
          }
        } else {
          setSubmitLoaderButton(false);
          setIsSectionValueEmpty(true);
          setTimeout(() => {
            setIsSectionValueEmpty(false);
          }, 4000);
        }
      } catch (error: any) {
        setSubmitLoaderButton(false);
        console.error("Error in POST request:", error);
        throw error;
      }
    });
  };

  const uploadChunksFromArray = (filesArray: any[]) => {
    promises = [];
    filesArray.forEach((chunksArray: any[], index) => {
      chunksArray.forEach(async (chunk: any, i) => {
        chunk.fileIndex = i;
        promises.push(postApiCall(`${baseUrl}Document/chunk`, chunk));
      });
    });
    Promise.all(promises)
      .then((res: any) => {
        largeFiles.forEach((largeFile: any) => {
          largeFile.fileAsBase64 = "";
          largeFile.tmpDirectory =
            largeFile.budgetYear +
            "/" +
            largeFile.assetPlanID +
            "/" +
            largeFile.sectionName +
            "/" +
            largeFile.tmpDirectory;
          postApiCall(`${baseUrl}Document/end`, largeFile);
        });
      })
      .catch((err) => {
        setToastMessageOpen(true);
        setSubmitLoaderButton(false);

        setToastMessage({
          message: err.message,
          severity: "error",
        });
        setTimeout(() => {
          setToastMessageOpen(false);
        }, 4000);
        dispatch(changeStatus(true));
      });
  };

  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const loadDocumentData = async (panel: string) => {
    await documentServices
      .getDocumentsBySectionAndAssetPlanId({
        section: panel,
        assetPlanId: assetPlanId,
      })
      .then((data: any) => {
        setDocumentData(data.documents);
      });
  };

  const handleAccordianChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  //logic to create new user...

  useEffect(() => {
    const sectionKey =
      dapData?.internationalInd === "Y"
        ? "GlobalDocumentSections"
        : "USDocumentSections";
    console.log("Fetching sections with key:", sectionKey);
    dispatch(fetchDocumentSections(sectionKey));
  }, [dispatch, dapData?.internationalInd]);

  const HandleSelectChange = (event: SelectChangeEvent) => {
    setSectionValue(event.target.value);
  };

  return (
    <div className="App document-wrap">
      <div className="doc-section-width">
        {toastMessageOpen && (
          <GenericToast
            message={toastMessage.message}
            severity={toastMessage.severity}
          />
        )}
        {isSectionValueEmpty && (
          <GenericToast
            message="Please Select Section From Dropdown"
            severity="error"
          />
        )}

        {props.mode == "edit" && (
          <div className="select-tab">
              <div className="doc-select-box">
                <label>Select Tab</label>
                <FormControl sx={{ m: 1, minWidth: 300 }}>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    onChange={HandleSelectChange}
                    defaultValue=""
                    disabled={documentSectionsLoading}
                  >
                    {documentSections.map((section) => (
                      <MenuItem key={section} value={section}>
                        {section}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {dapData?.investmentId.toLowerCase().includes("portfolio") && (sectionValue ==="Property Images") &&(
                <div className="doc-select-box">
                  <label>Investment Id</label>
                  <FormControl sx={{ m: 1, minWidth: 300 }}>
                    <Select
                      labelId="demo-simple-select-helper-label-investment"
                      id="demo-simple-select-helper-investment"
                      onChange={handleInvestmentIdChange}
                      value={selectedInvestmentId}
                      disabled={documentSectionsLoading}
                    >
                      {portfolioInvestments.map((investment: any) => (
                        <MenuItem
                          key={investment.investmentId}
                          value={investment.investmentId}
                        >
                          {investment.investmentId}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            {(sectionValue === "SitePlan" ||
              sectionValue === "StackingPlan") && (
              <span id="upload-image">Upload only images in this section</span>
            )}

            <label htmlFor="contained-button-file">
              <Input
                accept="image/*"
                id="contained-button-file"
                multiple
                type="file"
              />
            </label>
            <div>
              <label>Upload File</label>
              <p className="file-validation-msg">
                *Filename should not contain any special character except _ or -
              </p>
              <ReactFileUpload
                accept=".jpg,.png,.jpeg,.xlsx,.pdf"
                multiple
                updateFilesCb={updateUploadedFiles}
                sectionValue={sectionValue}
              />
              <LoadingButton
                disabled={
                  newUserInfo.profileImages.length === 0 ||
                  sectionValue === undefined ||
                  (sectionValue === "Property Images" && !selectedInvestmentId)
                }
                className={
                  newUserInfo.profileImages.length === 0 ||
                  sectionValue === undefined ||
                  (dapData?.investmentId.toLowerCase().includes("portfolio") && sectionValue === "Property Images" && !selectedInvestmentId)
                    ? "disabled-btn"
                    : "primary"
                }
                loading={submitLoaderButton}
                onClick={handleSubmit}
                variant="contained"
                component="span"
              >
                Upload Documents
              </LoadingButton>
            </div>
          </div>
        )}

        {documentSections.map((section) => (
          <Accordion
            key={section}
            expanded={expanded === section}
            onChange={handleAccordianChange(section)}
          >
            <AccordionSummary
              aria-controls={`${section}-content`}
              id={`${section}-header`}
            >
              <Typography>{section}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <DocumentComponent
                sectionName={section}
                assetPlanId={assetPlanId}
                document={documentData}
                mode={props.mode}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
}

export default Documents;
